<ng-container *ngIf="languageOptions() as options">
  <mat-form-field *ngIf="options.length > 1"
    [ngClass]="disabled ? 'custom-select-disabled' : 'custom-select'"
    appearance="fill"
  >
    <mat-select
      [(value)]="selectedLanguage"
      style="text-transform: uppercase"
      [disabled]="disabled"
      (selectionChange)="onLangChanged(selectedLanguage)"
    >
      <mat-option class="options" *ngFor="let option of options" [value]="option.value">
        <p style="text-transform: uppercase">{{option.label}}</p>
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>
